'use client';

import IconButton from '@mui/material/IconButton';
import { useModal } from '@prismo-io/design-system';
import type { FC } from 'react';
import { AiFillEdit } from 'react-icons/ai';
export const FormModalOpenBtn: FC = () => {
  const {
    onOpen
  } = useModal();
  return <IconButton onClick={onOpen} size="small" data-sentry-element="IconButton" data-sentry-component="FormModalOpenBtn" data-sentry-source-file="index.tsx">
      <AiFillEdit fontSize="small" data-sentry-element="AiFillEdit" data-sentry-source-file="index.tsx" />
    </IconButton>;
};